// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__37g9O","box":"WorkspacesBox_box__jzT-4","node":"WorkspacesBox_node__23crY"};